

<div class="container-fluid p-0">
  <div class="heightfull">
    <div class="col-md-12 contentbox">
      <div class="col-lg-8 offset-lg-2">
        <div class="card">
          <div class="row m-0">
            <div class="col-md-6 leftimg m-0 p-0">
              <div id="circle"></div>
              <div class="leftcontent">
                <p style="font-size: 31px">Welcome Back,</p>
                <p style="font-size: 10px" class="mb-0">Sign in for access</p>
              </div>
              <div id="oval"></div>
            </div>
            <div class="col-md-6 p-0">
              <div class="form_outer p-5">
                <div class="col-12 text-center box_">
                  <img
                  class="logoImg"
                    src="../../../assets/images/schoold_admin_logo1.svg"
                  />
                  <p class="logo_name">Schoold</p>
                </div>
                <div class="form_inner">
                  <form [formGroup]="loginForm">
                    <div class="inputs">
                      
                      <div class="form-group mt-3 mb-1">
                        <label class="mb-2">LOGIN</label>
                        <div class="position-relative">
                          <!-- <img
                            class="position-absolute inputimg"
                            src="../../../assets/images/mail.png"
                          /> -->
                          <input
                            type="text"
                            formControlName="email"
                            class="form-control login_input position-relative"
                            id="exampleInputEmail1"
                            placeholder="Email"
                          />
                          <div *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)" class="errorinput text-left">
                            <div *ngIf="loginForm.controls['email'].errors.required">
                              *Email is required.
                            </div>
                            <div *ngIf="loginForm.controls['email'].errors.pattern">
                                *Invalid email .
                              </div>
                        </div>
                        </div>
  
                        <div class="position-relative mt-3">
                          <!-- <img
                            class="position-absolute inputimg"
                            src="../../../assets/images/lock (1).png"
                          /> -->
                          <input
                            type="password"
                            formControlName="password" 
                            class="form-control login_input position-relative password_"
                            id="exampleInputEmail1"
                            placeholder="Password"
                            [type]="show ? 'text' : 'password'"
                          />
                          <img *ngIf="show == true" (click)="password()" class="show_password" src="../../../assets/images/password_show.png" alt="">
                            <img *ngIf="show == false"  (click)="password()" class="show_password" src="../../../assets/images/password_hide.png" alt="">

                          <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)" class="errorinput text-left">
                                                
                            <div *ngIf="loginForm.controls['password'].errors.required">
                              *Password is required.
                            </div>
                            <div *ngIf="loginForm.controls['password'].errors.minlength">
                              *Minimum password length is 8.
                            </div>
                        </div>
                        </div>
                        
                      </div>
                      <button  class="btn loginBtn mt-4 w-100" (click)="login()">LOGIN</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-spinner *ngIf="isLoading" [type]="'normal'"></app-spinner>